import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule as FaModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import {
    faAngleDown,
    faAngleUp,
    faArrowAltCircleLeft,
    faBars,
    faBatteryEmpty,
    faBatteryFull,
    faBatteryHalf,
    faBatteryQuarter,
    faBatteryThreeQuarters,
    faBell,
    faBook,
    faBoxOpen,
    faCalendar,
    faCaretDown,
    faCaravan,
    faCaretUp,
    faCheck,
    faChevronLeft,
    faChevronRight,
    faClock,
    faCog,
    faCrosshairs,
    faDownload,
    faEdit,
    faEllipsisH,
    faEllipsisV,
    faEnvelope,
    faExclamationCircle,
    faExclamationTriangle,
    faFileImage,
    faFilm,
    faFilter,
    faGhost,
    faGraduationCap,
    faHammer,
    faHistory,
    faHourglassHalf,
    faIdCardClip,
    faInfoCircle,
    faLink,
    faLocationDot,
    faLockOpen,
    faPaperPlane,
    faPencilAlt,
    faPlus,
    faPlusCircle,
    faQuestionCircle,
    faRedo,
    faRightFromBracket,
    faRotateLeft,
    faScroll,
    faSlash,
    faSortDown,
    faSortUp,
    faSyncAlt,
    faTableList,
    faTimes,
    faTimesCircle,
    faTrash,
    faTruckRampBox,
    faUndo,
    faUnlink,
    faUpload,
    faUsersSlash,
    faVolumeOff,
    faVolumeUp,
    faWrench,
    faCompass,
} from '@fortawesome/free-solid-svg-icons';


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
  ],
  exports: [
    FaModule,
  ],
})
export class FontAwesomeModule {
    constructor(
        private readonly _fa: FaIconLibrary
    ) {
        // this._fa.addIconPacks(fas, far);
        this._fa.addIcons(
            faAngleDown,
            faAngleUp,
            faArrowAltCircleLeft,
            faBars,
            faBatteryEmpty,
            faBatteryFull,
            faBatteryHalf,
            faBatteryQuarter,
            faBatteryThreeQuarters,
            faBell,
            faBook,
            faBoxOpen,
            faCalendar,
            faCaretDown,
            faCaravan,
            faCaretUp,
            faCheck,
            faChevronLeft,
            faChevronRight,
            faClock,
            faCog,
            faCrosshairs,
            faDownload,
            faEdit,
            faEllipsisH,
            faEllipsisV,
            faEnvelope,
            faExclamationCircle,
            faExclamationTriangle,
            faFileImage,
            faFilm,
            faFilter,
            faGhost,
            faGraduationCap,
            faHammer,
            faHistory,
            faHourglassHalf,
            faIdCardClip,
            faInfoCircle,
            faLink,
            faLocationDot,
            faLockOpen,
            faPaperPlane,
            faPencilAlt,
            faPlus,
            faPlusCircle,
            faQuestionCircle,
            faRedo,
            faRightFromBracket,
            faRotateLeft,
            faScroll,
            faScroll,
            faSlash,
            faSortDown,
            faSortUp,
            faSyncAlt,
            faTableList,
            faTimes,
            faTimesCircle,
            faTrash,
            faTruckRampBox,
            faUndo,
            faUnlink,
            faUpload,
            faUsersSlash,
            faVolumeOff,
            faVolumeUp,
            faWrench,
            faCompass,
        );
    }
}
